import { createContext, useCallback, useContext, useEffect, useState } from 'react';

/** Persists Movie Director panel visibility app-wide (scene grid, video editor, any future surfaces). */
export const MOVIE_DIRECTOR_PANEL_LS_KEY = 'scene_grid_show_movie_director';

function readStoredOpen() {
  try {
    if (typeof localStorage === 'undefined') return true;
    return localStorage.getItem(MOVIE_DIRECTOR_PANEL_LS_KEY) !== '0';
  } catch {
    return true;
  }
}

const MovieDirectorContext = createContext(null);

export function MovieDirectorProvider({ children }) {
  const [open, setOpenState] = useState(readStoredOpen);

  const setOpen = useCallback((value) => {
    setOpenState((prev) => {
      const next = typeof value === 'function' ? value(prev) : value;
      return Boolean(next);
    });
  }, []);

  useEffect(() => {
    try {
      localStorage.setItem(MOVIE_DIRECTOR_PANEL_LS_KEY, open ? '1' : '0');
    } catch {
      /* ignore */
    }
  }, [open]);

  return (
    <MovieDirectorContext.Provider value={{ open, setOpen }}>
      {children}
    </MovieDirectorContext.Provider>
  );
}

export function useMovieDirector() {
  const ctx = useContext(MovieDirectorContext);
  if (!ctx) {
    throw new Error('useMovieDirector must be used within MovieDirectorProvider');
  }
  return ctx;
}
